import ForgetPasswordContainer from "../pages/other-pages/authentication/forget-password/ForgetPassword";
import OtpLogin from "../pages/other-pages/authentication/otp-login/OtpLogin";
import Register from "../pages/other-pages/authentication/register/Register";

export const authRoutes = [
  {
    path: `${process.env.PUBLIC_URL}/authentication/forgetpassword`,
    Component: <ForgetPasswordContainer />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/otplogin`,
    Component: <OtpLogin />,
  },
  {
    path: `${process.env.PUBLIC_URL}/register`,
    Component: <Register />,
  },
];
